import React from 'react';
import Pagination from '@mui/material/Pagination';

interface NewpaginationProps {
  rows: number;
  pageSize: number;
  page: number;
  handlePageChange: (
    event: React.ChangeEvent<unknown>,
    newPage: number
  ) => void;
}

const Newpagination: React.FC<NewpaginationProps> = ({
  rows,
  pageSize,
  page,
  handlePageChange,
}) => {
  return (
    <Pagination
      size="small"
      count={Math.max(1, Math.ceil(rows / pageSize))}
      page={page + 1}
      onChange={handlePageChange}
      sx={{
        marginLeft: '50%',

        '& .MuiPaginationItem-root': {
          color: '#ffffffff',
        },
        '& .MuiPaginationItem-root.Mui-selected': {
          background: 'linear-gradient(1turn, rgb(211, 211, 211), rgb(255, 255, 255))',
          color: 'black',
        },
        '& .MuiPaginationItem-root.Mui-selected:hover': {
          backgroundColor: '#e7e7e7ff',
        },
      }}
    />
  );
};

export default Newpagination;
